import './SofaSectionPanel.css';
type Props = React.PropsWithChildren<{}>;

export const SofaSectionPanel = ({ children }: Props) => (
  <div className="sofa-section-panel">{children}</div>
);
